import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Frame, SageTokens, useSageBreakpoint } from '@kajabi/sage-react';

const Circle = () => (
  <div
    style={{ background: '#b5bac0', height: 10, width: 10, borderRadius: 100 }}
  />
);

const MOCK_BROWSER_STYLE = `
  @keyframes mock-browser-fade-in {
    0%   { opacity: 0; }
    50%  { opacity: 0; }
    100% { opacity: 1; }
  }

  @keyframes mock-browser-fade-out {
    0%   { opacity: 1; }
    50%  { opacity: 0; }
    100% { opacity: 0; }
  }
`;

const ANIMATION_DURATION = 0.5;

export const MockBrowser = ({ fadeOut, children, intervalTime }) => {
  const breakpoints = useSageBreakpoint();

  const dynamicMockBrowserStyle = useMemo(() => {
    const baseStyling = {
      animationDelay: `${
        fadeOut ? intervalTime / 1000 - ANIMATION_DURATION : 0
      }s`,
      animationDuration: `${ANIMATION_DURATION}s`,
      animationName: `mock-browser-fade-${fadeOut ? 'out' : 'in'}`,
      animationTimingFunction: fadeOut ? 'ease-out' : 'ease-in',
      animationFillMode: 'forwards',
      overflowY: 'hidden',
    };

    if (breakpoints.sm) {
      return {
        ...baseStyling,
        height: '100%',
        borderRadius: 32,
        borderWidth: 16,
        borderColor: '#ECEEEF',
        borderStyle: 'solid',
      };
    }
    return {
      ...baseStyling,
      borderRadius: 16,
      boxShadow: '0px 20px 40px 0px rgba(0, 0, 0, 0.1)',
      height: '100%',
    };
  }, [breakpoints, fadeOut, intervalTime]);

  return (
    <Frame
      align={Frame.ALIGNMENTS.BOTTOM_CENTER}
      style={{ height: '100%', overflowY: 'clip' }}
    >
      <style children={MOCK_BROWSER_STYLE} />
      <Frame gap={Frame.GAPS.NONE} style={dynamicMockBrowserStyle}>
        {breakpoints.sm || (
          <Frame
            background={SageTokens.COLOR_PALETTE.GREY_300}
            direction={Frame.DIRECTIONS.HORIZONTAL}
            gap={Frame.GAPS.XS}
            padding={Frame.PADDINGS.SM}
            style={{ borderRadius: '25px 25px 0 0' }}
          >
            <Circle />
            <Circle />
            <Circle />
          </Frame>
        )}
        <Frame style={{ overflowY: 'scroll' }}>{children}</Frame>
      </Frame>
    </Frame>
  );
};

MockBrowser.propTypes = {
  fadeOut: PropTypes.bool.isRequired,
  intervalTime: PropTypes.number.isRequired,
};
